import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class SessionAnuglarService {

  private static _homeInstance = 0;
  public static limitInstace = new EventEmitter<any>();

  public static accessHome() {
    const llint = localStorage.getItem('accessHome');
    this._homeInstance = llint ? parseInt(llint, 10) : 0;
    this._homeInstance++;
    localStorage.setItem('accessHome', this._homeInstance.toString(10));
    if(this._homeInstance > 1) {
      this.limitInstace.emit(true);
    }
  }

  public static getAccess() {
    return this._homeInstance;
  }

  constructor() { }

  static getToken(): string {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let token = currentUser && currentUser.token;
    return token ? token : '';
  }

	static getTokenApiAlerta(): string {
		return localStorage.getItem('api-alerta-token');
	}

	static setTokenApiAlerta(token: string): void {
		localStorage.setItem('api-alerta-token', token);
	}

  static logout(): void {
      // clear token remove user from local storage to log user out
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if(currentUser && currentUser.login) {
        localStorage.removeItem(currentUser.login);
      }
      localStorage.removeItem('currentUser');
      localStorage.removeItem('accessHome');
      localStorage.removeItem('parametros');
      localStorage.removeItem('telaMedico');
      this._homeInstance = 0;
  }

  static isLoggedIn(): boolean {
    let token: String = this.getToken();
    return token && token.length > 0;
  }

  static telaDoMedico(open: boolean) {
    if (open) {
      localStorage.setItem('telaMedico', 'S');
    } else {
      localStorage.setItem('telaMedico', 'N');
    }
  }

  static verificaTelaMedico(): boolean {
    return localStorage.getItem('telaMedico') && localStorage.getItem('telaMedico') === 'S';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/session-anuglar.service.ts